export default "__VITE_ASSET__D3uDuUYu__"